/**
 * Our comments controller
 */
angular.module('ffApp').controller('CommentsController', ['$scope', '$resource', '$sce', '$http', function($scope, $resource, $sce, $http)
{
	$scope.comments = null;
	$scope.commentsTotalCount = 0;
	$scope.filter = null;
	$scope.userInfo = $resource('/api/me').get();
	$scope.formErrors = null;
	$scope.commentPostInProgress = false;

	$scope.form = {};

	var limit = 3;
	var offset = 0;
	var postId = null;
	var commentsResource = $resource('/api/podcast/:post_id/comments');

	$scope.$watch('$parent.currentEpisode', function(newValue, oldValue)
	{
		var newId = (typeof newValue.post_id != 'undefined' ? newValue.post_id : null);
		var oldId = (typeof oldValue.post_id != 'undefined' ? oldValue.post_id : null);

		// New podcast is loaded
		if ( newId !== null && newId != oldId )
		{
			$scope.setDefaultFormData();

			postId = newId;
			offset = 0;

			$scope.commentsTotalCount = 0;
			$scope.comments = commentsResource.query({post_id: postId, limit: limit}, function(data, responseHeaders)
			{
				$scope.commentsTotalCount = responseHeaders('comment-count');
			});
		}
	}, true);

	/**
	 * Load more comments
	 */
	$scope.loadMore = function()
	{
		offset += limit;

		$scope.comments.$resolved = false;
		$scope.commentsTotalCount = 0;

		commentsResource.query({post_id: postId, limit: limit, offset: offset}, function(data, responseHeaders)
		{
			$scope.commentsTotalCount = responseHeaders('comment-count');

            if (data.length > 0)
			{
                $scope.comments = $scope.comments.concat(data);
            }
			else
			{
				}

			$scope.comments.$resolved = true;
        });
	};

	/**
	 * Filter comments
	 *
	 * @param filter
	 */
	$scope.filterComments = function(filter)
	{
		offset = 0;
		$scope.filter = filter;

		var params = {post_id: postId, limit: limit, filter: $scope.filter};

		if ( $scope.filter == null )
		{
			params = {post_id: postId, limit: limit};
		}

		$scope.commentsTotalCount = 0;
		$scope.comments = commentsResource.query(params, function(data, responseHeaders)
		{
			$scope.commentsTotalCount = responseHeaders('comment-count');
		});
	};

	/**
	 * Return true if there are more comments that can be loaded/shown
	 *
	 * @returns {boolean}
	 */
	$scope.isThereMore = function()
	{
		var commentCount = $scope.comments != null ? $scope.comments.length : 0;

		return commentCount < $scope.commentsTotalCount && $scope.commentsTotalCount > 0;
	};

	/**
	 * Return logout url
	 *
	 * @returns {string}
	 */
	$scope.getLogoutUrl = function()
	{
		return $scope.userInfo.logout_url + '?redirect=' + encodeURIComponent(window.location);
	};

	/**
	 * Set comment type
	 *
	 * @param type
	 */
	$scope.setCommentType = function(type)
	{
		$scope.form.type = type;


	};

	$scope.setDefaultFormData = function()
	{
		var type = $scope.form.type ? $scope.form.type : 'text'; // Default

		$scope.form = {
			type: type,
			comment_text: '',
			youtube_link: '',
			spotify_link: '',
			was_wrong: '',
			image: '',
			image_url: ''
		};

		$scope.formErrors = null;

		$('#comment-form').trigger('reset');
	};

	/**
	 * Handle image upload
	 */
	$scope.uploadImage = function()
	{
		var form = $('#comment-form');
		var iframe = $('<iframe id="comment-image-upload-iframe" name="comment-image-upload-iframe" src="about:none"/>').appendTo('body');

		iframe.one('load', function()
		{
			var response = angular.fromJson(iframe.contents().find('body').html());

			if ( response.error != true )
			{
				$scope.form.image = response.filename;
				$scope.form.image_url = response.url;
			}
			else
			{
				$scope.form.image = '';
				$scope.form.image_url = '';
			}

			iframe.remove();

			$scope.$parent.maybeDigest();
		});

		form.attr('action', '/api/comment-image');
		form.attr('target', 'comment-image-upload-iframe');

		// Givet the iframe some timet to settle in...
		setTimeout(function()
		{
			form.submit();
		}, 100);
	};

	$scope.postComment = function()
	{
		if ( $scope.commentPostInProgress )
		{
			// Post is already in progress
			return;
		}

		$scope.formErrors = null;
		$scope.commentPostInProgress = true;

		var data = angular.copy($scope.form); // A copy please, not a reference!
		data.comment_position = $scope.$parent.selectedTime;

		$http({
			method: 'POST',
			url: '/api/podcast/' + postId + '/comments',
			data: $.param(data),
			headers: {'Content-Type': 'application/x-www-form-urlencoded'}
		})
			.then(function(response)
			{
				var data = response.data;
				if (data.error == true)
				{
					$scope.formErrors = data.validation_errors;
				}
				else
				{
					// All good, reload comments
					$scope.setDefaultFormData();
					$scope.filterComments();
					$scope.$parent.reloadPodcastData();
				}

				$scope.commentPostInProgress = false;
			}, function()
			{
				$scope.commentPostInProgress = false;
				$scope.formErrors = [{message: 'Unknown error.'}];
			});
	};

	$scope.setDefaultFormData();
}]);